import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Footer from "./Footer";
import "../styles/NotFound.scss";
import { isMobile } from "react-device-detect";
import { useAuth } from "react-oidc-context";
import IdleUserHeader from "./IdleUserHeader";
import AuthService from "src/services/AuthService";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { PersistState } from "src/redux/reducers/PersistSlice";
import { UserManager } from "oidc-client-ts";
import { OIDC_CONFIG } from "../utility/Keycloak";
import { useNavigate } from "react-router";
import { PAGE } from "../constants/page";
import HttpService from "src/services/HttpService";
import { errorUpdate } from "src/redux/reducers/LoaderSlice";
type Props = {};

const IdleUserMobile = (props: Props) => {
  const auth = useAuth();
  const userLanguage = useAppSelector(PersistState);
  const userManager = new UserManager(OIDC_CONFIG);
  const navigate = useNavigate();
  const httpService = HttpService.instance;
  const dispatch = useAppDispatch();

  const handleBackButtonClick = () => {
    window.removeEventListener("popstate", handleBackButtonClick);
    auth.signinRedirect({
      prompt: "login",
      extraQueryParams: {
        action: "asha_login",
        ui_locales: userLanguage?.language || "en",
      },
    });
  };

  useEffect(() => {
    window.addEventListener("popstate", handleBackButtonClick);
    return () => {
      window.removeEventListener("popstate", handleBackButtonClick);
    };
  }, []);

  const handleLoginClicked = () => {
    window.removeEventListener("popstate", handleBackButtonClick);
    auth.signinRedirect({
      prompt: "login",
      extraQueryParams: {
        action: "asha_login",
        ui_locales: userLanguage?.language || "en",
      },
    });
  };

  return (
    <>
      <IdleUserHeader />
      <div className="not-found-background-container">
        <div
          className={
            isMobile
              ? "d-flex flex-column not-found-container-mobile"
              : "d-flex flex-row justify-content-center not-found-container-desktop align-items-baseline"
          }
        >
          <div className="image-container">
            <img src="/icons/404_icon.svg" />
          </div>
          <div className="text-container">
            <div className="text-not-found-title">Session timed out</div>
            <div className="text-not-found-content">
              Your session has timed out due to inactivity. Please login again
              to continue
            </div>
            <Button
              className="text-not-button-go-home"
              onClick={() => handleLoginClicked()}
            >
              Go to Login
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default IdleUserMobile;
